import CandidateIcon from '@grnhse/seedling/lib/birch/icons/candidate';
import CheckIcon from '@grnhse/seedling/lib/birch/icons/check';
import ConfigureIcon from '@grnhse/seedling/lib/birch/icons/configure';
import DiversityIcon from '@grnhse/seedling/lib/birch/icons/diversity';
import DocFileIcon from '@grnhse/seedling/lib/birch/icons/doc_file';
import FormsIcon from '@grnhse/seedling/lib/birch/icons/forms';
import JobIcon from '@grnhse/seedling/lib/birch/icons/job';
import LinkIcon from '@grnhse/seedling/lib/birch/icons/link';
import ScorecardIcon from '@grnhse/seedling/lib/birch/icons/scorecard';
import ShieldCheckIcon from '@grnhse/seedling/lib/birch/icons/shield_check';
import { IconProps } from '@grnhse/seedling/lib/birch/icons/base';

type FamilyIcon = (props: IconProps) => JSX.Element;

const FAMILY_ICONS: Record<string, FamilyIcon> = {
  candidates_and_prospects: CandidateIcon,
  applications: FormsIcon,
  jobs_and_openings: JobIcon,
  interviews_and_scorecards: ScorecardIcon,
  offers_and_compensation: DocFileIcon,
  approvals: CheckIcon,
  users_and_permissions: ShieldCheckIcon,
  organization_setup: ConfigureIcon,
  compliance_and_demographics: DiversityIcon,
  integrations: LinkIcon,
};

export function familyIcon(familyKey: string): FamilyIcon {
  return FAMILY_ICONS[familyKey] ?? FormsIcon;
}
